import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTowerWithPacking = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 97,
	viewBox: "0 0 14.0 97.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 14.0 3.5 L 14.0 93.5 A 5.0 2.5 0.0 0 1 0.0 93.5 L 0.0 3.5 A 5.0 2.5 0.0 0 1 14.0 3.5 Z M 0.0 3.5 L 14.0 3.5 M 0.0 93.5 L 14.0 93.5 M 0.0 43.5 L 14.0 43.5 M 0.0 53.5 L 14.0 53.5 M 0.0 18.5 L 14.0 18.5 M 0.0 78.5 L 14.0 78.5 M 14.0 18.5 L 0.0 43.5 M 14.0 43.5 L 0.0 18.5 M 14.0 53.5 L 0.0 78.5 M 14.0 78.5 L 0.0 53.5",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgTowerWithPacking;
